import React, { useEffect, useMemo, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { useSelector } from "react-redux";
import { selectSidebarCollapsed } from "../store/slices/app/appSelector";
import { selectUserDb } from "../store/slices/session/sessionSelector";
import InternalCampaignsTab from "../components/processor/InternalCampaignsTab";
import AsyncOperationsTab from "../components/processor/AsyncOperationsTab";
import { useTranslation } from "react-i18next";
import PageBreadcrumbs from "../components/layout/PageBreadcrumbs";

const Processor: React.FC = () => {
  const collapsed = useSelector(selectSidebarCollapsed);
  const userDb = useSelector(selectUserDb);
  const isAdmin = userDb?.role === "ADMIN";
  const { t } = useTranslation();

  const [selectedTab, setSelectedTab] = useState<"internal" | "async">(
    "internal"
  );
  const [asyncPage, setAsyncPage] = useState(0);
  const [asyncRowsPerPage, setAsyncRowsPerPage] = useState(20);

  useEffect(() => {
    if (!isAdmin && selectedTab === "async") {
      setSelectedTab("internal");
    }
  }, [isAdmin, selectedTab]);

  const availableTabs = useMemo(() => {
    const tabs: {
      value: "internal" | "async";
      label: string;
      disabled?: boolean;
    }[] = [
      {
        value: "internal",
        label: t("processor.tabs.processor", {
          defaultValue: "Processor",
        }),
      },
    ];

    if (isAdmin) {
      tabs.push({
        value: "async",
        label: t("processor.tabs.asyncOperations", {
          defaultValue: "Async Operations",
        }),
      });
    }

    return tabs;
  }, [isAdmin, t]);

  const handleTabChange = (
    _event: React.SyntheticEvent,
    value: "internal" | "async"
  ) => {
    setSelectedTab(value);
  };

  return (
    <Box sx={{ display: "flex" }}>

      <Box
        sx={{
          flexGrow: 1,
          p: 3,
          transition: "margin-left 0.3s ease",
          marginLeft: collapsed ? "80px" : "250px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <PageBreadcrumbs />

        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}
          variant="scrollable"
          allowScrollButtonsMobile
        >
          {availableTabs.map((tab) => (
            <Tab key={tab.value} value={tab.value} label={tab.label} />
          ))}
        </Tabs>

        {selectedTab === "internal" && (
          <InternalCampaignsTab isAdmin={isAdmin} />
        )}

        {selectedTab === "async" && isAdmin && (
          <AsyncOperationsTab
            page={asyncPage}
            rowsPerPage={asyncRowsPerPage}
            onPageChange={setAsyncPage}
            onRowsPerPageChange={setAsyncRowsPerPage}
          />
        )}
      </Box>
    </Box>
  );
};
export default Processor;
